// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cart-icon{color:#333;font-weight:500;transition:color .3s ease}.cart-icon:hover{color:#007bff;text-decoration:none}.jquery_text{font-size:.95rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
